import { template as template_4fadc8ebd7424469bcb7622e6a101638 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import Message from 'ember-simplepractice/components/spds/feedback/alert-banner/message';
import styles from './pending-insurance-info-banner.module.scss';
export default class SiteBillingInsurancePendingInsuranceInfoBanner extends Component {
    title = (pendingInsuranceInfoCount)=>{
        if (pendingInsuranceInfoCount === 1) {
            return '1 new insurance info is pending approval';
        } else {
            return `${pendingInsuranceInfoCount} new insurance infos are pending approval`;
        }
    };
    static{
        template_4fadc8ebd7424469bcb7622e6a101638(`
    <div class={{styles.component}}>
      <Message
        @type="info"
        @includeIcon={{true}}
        @classNames="icon-inline"
        @header={{this.title @pendingInsuranceInfoCount}}
        data-test-pending-insurance-info-banner
      >
        <:body>
          You will be notified when your insurance info has been accepted and applied
        </:body>
      </Message>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
